// extracted by mini-css-extract-plugin
export default {"container":"Whatsapp_container__lLGsJ","whatsapp_icon":"Whatsapp_whatsapp_icon__fbvY9"};